export const RESIDENCE_PLACE_ID_FIELD = 'residencePlaceId';

// Wires the residence autocomplete into the form: a selection pins its place id so
// the server resolves the exact place, and free-typing clears the id so the server
// re-geocodes the edited text (HUB-1830).
export const makeResidenceLocationHandlers = (setValue, { onChange, onSelect } = {}) => ({
    handleChange: (location) => {
        setValue(RESIDENCE_PLACE_ID_FIELD, null);
        if (onChange) {
            onChange(location);
        }
    },
    handleSelect: (location, placeId) => {
        setValue(RESIDENCE_PLACE_ID_FIELD, placeId);
        if (onSelect) {
            onSelect(location);
        }
    },
});
